<template>
	<v-container>
		<v-row class="contentRow">
			<v-col cols="12">
				<h1 class="mb-2">Edit Risk</h1>
			</v-col>

			<v-col align="center">
				<v-form v-model="valid">
					<v-col>
						<v-col>
							<v-text-field outlined width="50%" label="Risk" v-model="connections[0].Risk"
								:rules="[rules.inputRules]" :disabled="connections[0].updatedconsequence != null"/>
						</v-col>
						<v-col>
							<v-text-field outlined width="50%" label="Risk Description"
								v-model="connections[0].RiskDescription" value="risk" :rules="[rules.inputRules, rules.maxWords]" :disabled="connections[0].updatedconsequence != null"/>
						</v-col>
						<v-col>
							<v-text-field outlined width="50%" label="Types of Risk"
								v-model="connections[0].TypesOfRisk" :rules="[rules.inputRules]" :disabled="connections[0].updatedconsequence != null"/>
						</v-col>
						<v-col>
							<v-text-field outlined label="Risk Owner" v-model="connections[0].RiskOwner"
								:rules="[rules.inputRules]" :disabled="connections[0].updatedconsequence != null"/>
						</v-col>
						<v-col>
							<v-text-field type="date" outlined label="Created" v-model="connections[0].Created"
								:rules="[rules.inputRules]" :disabled="connections[0].updatedconsequence != null"/>
						</v-col>
						<v-col>
							<v-text-field outlined label="Creator" v-model="connections[0].Creator"
								:rules="[rules.inputRules]" :disabled="connections[0].updatedconsequence != null"/>
						</v-col>
						<v-col>
							<v-text-field type="number" outlined label="Consequence: select a number between (0-25)"
								v-model="connections[0].Consequence" :rules="[rules.inputRules, rules.maxConsequence , rules.isInteger]" :disabled="connections[0].updatedconsequence != null"/>
						</v-col>
						<v-col>
							<v-text-field type="number" outlined label="Probability:  select a number between (0-25)"
								v-model="connections[0].Probability" :rules="[rules.inputRules, rules.maxProbability, rules.isInteger] " :disabled="connections[0].updatedconsequence != null"/>
						</v-col>
						<!-- <v-col>
						<v-alert color="primary" type="info">
							Note: <b>{{ (risk || riskdescription) ? risk + " " + riskdescription : "The new user" }}</b> must
							verify their e-mail address before logging in. A verification e-mail will be sent to
							<b>{{ typesofrisk || "their e-mail" }}</b> when you click 'Add user'
						</v-alert>
					</v-col> -->
						<v-col align="right">
							<v-btn class="mr-10" color="primary" 
								@click="updateRisk(connections[0].RiskID,connections[0].Risk, connections[0].RiskDescription, connections[0].TypesOfRisk, connections[0].RiskOwner, connections[0].Created, connections[0].Creator, connections[0].Consequence, connections[0].Probability)"
								:disabled="!valid ||connections[0].updatedconsequence != null">
								Edit Risk</v-btn>
							<v-btn class="mr-10" color="primary" @click="show = !show" :disabled="!valid"  v-if="connections[0].updatedconsequence != null">
								Update of this Risk</v-btn>
						</v-col>
					</v-col>
				</v-form>
				<v-form v-model="d">
					<v-col v-if="show">
						<v-col cols="12">
							<h1 class="mb-2">Update the New Status Of the Risk</h1>
						</v-col>
						<v-col cols="12">
							<p class="mb-2">Please update the status of the risk if there have been any changes in its consequence or probability or both. Additionally, review the journey of the risk from its starting point to ensure a comprehensive understanding of its progression.</p>
						</v-col>
						<br/>
						<v-col>
							<v-text-field type="date" outlined label="UpdateCreated" v-model="UpdatedDate"
								:rules="[rules2.inputRules2nd]" />
						</v-col>

						<v-col>
							<v-text-field type="number" outlined label="Updated Consequence: select a number between (0-25)"
								v-model="connections[0].updatedconsequence" :rules="[rules.inputRules, rules.maxConsequence , rules.isInteger]" />
						</v-col>
						<v-col>
							<v-text-field type="number" outlined label="Updated Probability:  select a number between (0-25)"
								v-model="connections[0].updatedprobability" :rules="[rules.inputRules, rules.maxProbability, rules.isInteger] " />
						</v-col>
						<v-col>
							<v-text-field type="text" outlined
								label="Comment" v-model="connections[0].CommentforUpdate"
								:rules="[rules2.inputRules2nd]" />
						</v-col>
						<v-col>
							<v-btn class="mr-10" color="primary"
								@click="updatedRisk(connections[0].RiskID, UpdatedDate, connections[0].updatedconsequence, connections[0].updatedprobability, connections[0].CommentforUpdate)"
								:disabled="!d">
								Add Update to Risk</v-btn>
						</v-col>
					</v-col>
				</v-form>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { riskAPI } from "../api/csr/risk"
import LoadingState from "../consts/LoadingState"

export default {
	name: "Add Risk New Point",
	data() {
		return {
			RiskID: "",
			itemId: null,
			connections: [],
			show: false,
			valid: false,
			d: false,
			typesofrisk: "",
			riskowner: "",
			consequence: "",
			createddate: "",
			creator: "",
			risk: "",
			riskdescription: "",
			probability: null,
			updatedcreateddate: null,
			updatedconsequence: null,
			updatedprobability: null,
			rules: {
				inputRules: v => !!v || "Field is required!",
				maxConsequence: v => (v <= 25) || "Value must be 25 or less",
				maxProbability: v => (v <= 25) || "Value must be 25 or less",
				isInteger: v => Number.isInteger(Number(v)) || "Value must be an integer",
				maxWords: v => (v.split(/\s+/).length <= 20) || "Risk description can only contain up to 20 words"
			},
			rules2: {
				inputRules2nd: v => !!v || "Field is required!",
			}
		}
	},
	mounted() {
		this.itemId = this.$route.query.itemId
		console.log(this.itemId)
		this.loadRiskdata()
		this.$store.commit("setSelectedNewstate", true)
	},
	methods: {
		updateRisk(RiskID, risk, riskdescription, typesofrisk, riskowner, createddate, creator, consequence, probability) {
			console.log(RiskID)
			// this.$store.dispatch(
			// 	"loading/" + LoadingState.ACTION_START_LOADING,
			// 	{ root: true }
			// )
			alert("risk updated")

			riskAPI.updateRiskById(RiskID, risk, riskdescription, typesofrisk, riskowner, createddate, creator, consequence, probability)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Sucessfully Updated Risk!",
						{ root: true }
					)
					this.$router.push({ path: "/risk/riskpage" })
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		updatedRisk: function (RiskID, UpdatedDate, UpdatedConsequence, UpdatedProbability, CommentforUpdate) {
			console.log(RiskID, UpdatedDate, UpdatedConsequence, UpdatedProbability, CommentforUpdate)

			alert("risk new point updated")

			riskAPI.updateRiskNewPointById(RiskID, UpdatedDate, UpdatedConsequence, UpdatedProbability, CommentforUpdate)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Sucessfully new point Updated Risk!",
						{ root: true }
					)
					this.$router.push({ path: "/risk/riskpage" })
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		loadRiskdata() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			riskAPI.getRiskById(this.itemId)
				.then((data) => {
					let entry1 = data[0]
					let entry = entry1[0]
					console.log(entry)
					this.connections.push({
						RiskID: entry.RiskID,
						Risk: entry.Risk,
						RiskDescription: entry.RiskDescription,
						TypesOfRisk: entry.TypeOfRisk,
						RiskOwner: entry.RiskOwner,
						Created: entry.Created.split("T")[0],
						Creator: entry.Creator,
						Consequence: entry.Consequence,
						Probability: entry.Probability,
						updatedconsequence: entry.UpdatedConsequence,
						updatedprobability: entry.UpdatedProbability
					})
					// Can't make a check inside for loop (eslint), have to remove it outside. Not a good fix.
					/*					this.connections = this.connections.filter(function (obj) {
						return obj.clientID !== 1 // clientID 1 is the user (client accessing the portal).
					}) */
					// Used by old method of showing sustainability
					//this.averageScore() // Calculating average score of all suppliers 
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((error) => {
					console.log("I am here in update")
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		}
	}
}
</script>

<style scoped>
	.v-application .mr-10 {
		margin-right: 0px !important;
		margin-left: 40px !important;
	}
</style>
